import React, { useEffect, useState } from "react";
import { Form, Button, InputNumber, Radio, Input } from "antd";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";
import { ContainerModal } from "../../container/ContainerModal";

const initForm = {
	amount: 0,
	comment: "",
	currency: "MXN",
	designHours: 0,
	modelingHours: 0,
	planningHours: 0,
	unityHours: 0,
	webHours: 0,
	testingHours: 0,
};

const areasInput = [
	{ name: "webHours", title: "Programación Web" },
	{ name: "unityHours", title: "Programación Unity" },
	{ name: "modelingHours", title: "Arte 3D" },
	{ name: "designHours", title: "Diseño UI/UX" },
    { name: "planningHours", title: "Planeación" },
];
const keyDevelop = ["webHours", "unityHours", "modelingHours", "designHours", "testingHours"];

export const FormUpdateHours = ({ type = 0, dataForm = [], idSelect = "", title = "", editFormForProjectDetails, closeModalDetails }) => {

	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);

	const [developmentHours, setDevelopmentHours] = useState(0);

	useEffect(() => {
		if (type === 0) {
			form.setFieldsValue(initForm);
		} else {
			form.setFieldsValue(dataForm);
			setHrsDevelopment(dataForm);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setHrsDevelopment = (values) => {
		const sum = keyDevelop.reduce((prev, key) => prev + (values[key] || 0), 0);
		setDevelopmentHours(sum);
	};

	const finishForm = async (values) => {
		setLoading(true);
		const { comment, currency, ...hours } = values;
		const sanitizedHours = Object.fromEntries(Object.entries(hours).map(([key, value]) => [key, value === null ? 0 : value]));
		const jsonForm = {
			...sanitizedHours,
			comment,
			currency,
			developmentHours,
			totalHours: developmentHours + sanitizedHours.planningHours,
			type: type,
			idSelect: idSelect,
		};

        await editFormForProjectDetails(typeForDetailsProyect.updateHrs, jsonForm);
        setLoading(false);
	};

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={title}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<Form
					form={form}
					onFinish={finishForm}
					layout="vertical"
					className="w-full flex flex-col"
					onValuesChange={(_, allValues) => {
						setHrsDevelopment(allValues);
					}}
				>
					<div className="grid grid-cols-3 gap-x-4">
						{areasInput.map((area, index) => (
							<div key={`${index}-area-input`}>
								<Form.Item name={area.name} label={area.title} className="">
									<InputNumber placeholder="Horas" min={0} className="w-full" />
								</Form.Item>
							</div>
						))}
						<div className="flex flex-col gap-2">
							<p>Horas de desarrollo</p>
							<p>{developmentHours}</p>
						</div>
					</div>
					<div className="grid grid-cols-3 gap-x-4">
						<Form.Item name={"testingHours"} label={"Testing"} className="">
							<InputNumber placeholder="Horas" min={0} className="w-full" />
						</Form.Item>
					</div>
					<div className="grid grid-cols-3 gap-x-4">
						<Form.Item name={"amount"} label={"Costo"} className="">
							<InputNumber placeholder="Horas" min={0} className="w-full" />
						</Form.Item>
						<Form.Item name="currency" label="Moneda">
							<Radio.Group>
								<Radio.Button value="USD">USD</Radio.Button>
								<Radio.Button value="MXN">MXN</Radio.Button>
							</Radio.Group>
						</Form.Item>
					</div>
					<Form.Item
						name="comment"
						label="Comentario"
						rules={[
							{
								required: true,
								message: "Agrega un comentario",
								whitespace: true,
							},
						]}
					>
						<Input.TextArea
							placeholder="Comentario"
							autoSize={{
								minRows: 5,
								maxRows: 5,
							}}
							showCount={false}
						/>
					</Form.Item>
					<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
						<Button htmlType="button" onClick={closeModalDetails}>
							Cancelar
						</Button>
						<Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
							Guardar
						</Button>
					</div>
				</Form>
			</ContainerModal>
		</div>
	);
};
